import Emoji from './Emoji';
import { ShiftData } from '../../../types/TymbeApi';

type ShiftTemplateBoxProps = {
  shift: ShiftData;
};

const ShiftTemplateBox = ({ shift }: ShiftTemplateBoxProps) => {
  return (
    <div className="flex rounded-2xl h-10 shadow-down-xs items-center bg-white justify-between p-1 pr-2">
      <span className="flex items-center gap-2">
        <Emoji
          emoji={shift.emoji || shift.shiftTemplate?.emoji}
          className="bg-secondary-50 rounded-lg size-8 p-1"
        />
        {shift.shiftTemplate?.template_name}
      </span>
    </div>
  );
};

export default ShiftTemplateBox;
